
/** This file is generated automatically before build. DO NOT MODIFY **/
export default {
  "imgBase": "/sekai-stickers/img"
};
